__turbopack_context__.v({
  "bioContainer": "ProfileDetails-module-scss-module__yhgx8a__bioContainer",
  "bioContent": "ProfileDetails-module-scss-module__yhgx8a__bioContent",
  "bioTitle": "ProfileDetails-module-scss-module__yhgx8a__bioTitle",
  "editView": "ProfileDetails-module-scss-module__yhgx8a__editView",
  "missingData": "ProfileDetails-module-scss-module__yhgx8a__missingData",
  "missingDataHeader": "ProfileDetails-module-scss-module__yhgx8a__missingDataHeader",
  "root": "ProfileDetails-module-scss-module__yhgx8a__root",
});
